import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'

export const StyledSeparator = styled.div`
  margin: auto;
  width: 95%;
  height: ${pxToRem(1)};
  background-color: ${({theme}) => theme.colors.secondary.grey90};
  opacity: 0.5;
`

export const StyledSideNavBar = styled.ul`
  border-radius: ${pxToRem(5)};
  border: ${({theme}) => `${pxToRem(2)} solid ${theme.colors.unique.white}`};
  display: block;
  overflow-y: auto;
  width: ${pxToRem(384)};

  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

`
export const StyledSideNavBarSubList = styled.ul``

export const StyledSeparatorDiv = styled.div`
  justify-content: center;
  display: flex;
  background-color: ${({theme}) => theme.colors.unique.white};
`
